import { auth } from '../firebase/config';

export const syncWorkspaceCalendarEvent = async (payload) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Sesión de administrador requerida.');
  const token = await user.getIdToken();
  const response = await fetch('/api/workspace-calendar.php', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || 'Google Workspace Calendar no respondió.');
  return result;
};
